export default class DonateFormController {
  constructor() {
    this.form = null;
    this.amountInput = null;

    if (document.querySelector("section.blDonateForm")) {
      this.init();
    }
  }

  init() {
    this.form = document.querySelector("section.blDonateForm");
    this.amountInput = this.form.querySelector(".amountInput input");

    this.setEventListeners();
  }

  setEventListeners() {
    if (this.amountInput) {
      this.amountInput.addEventListener("focus", (e) => {
        this.amountInput.select();
      });
    }
  }
}
